<app-page-wrapper scrollable="true">
  <div class="invite-code-wrap">
    <app-heavy-header
      title="Enter Trusted Contact Code"
      mb="20px">
    </app-heavy-header>

    <section class="redeem-panel">
      <div class="phone-lock-banner">
        <div class="lock-mark" aria-hidden="true"></div>
        <div>
          <div class="banner-title">Code paired to your phone</div>
          <div class="banner-copy">
            Trusted contact codes can only be redeemed by the verified mobile number they were created for. We will match this code to your number<span *ngIf="mobileNumber">, {{ formatPhone(mobileNumber) }}</span>.
          </div>
        </div>
      </div>

      <form (ngSubmit)="submit()" #form="ngForm" class="invite-code-form">
        <div class="field-set">
          <label class="set-label" for="code">Invite Code</label>
          <app-base-input
            id="code"
            name="code"
            placeholder="TC-XXXX-XXXX"
            [(ngModel)]="code"
            autocomplete="off"
            isFluid="true"
            required>
          </app-base-input>
        </div>

        <app-alert-message *ngIf="error" type="error" mb="14px">{{ error }}</app-alert-message>

        <app-primary-btn
          [disabled]="isLoading || !code.trim()"
          [isLoading]="isLoading"
          gradient="true">
          Redeem Code
        </app-primary-btn>
      </form>
    </section>
  </div>
</app-page-wrapper>
